import { useState } from 'react';
import { usersAPI } from '@/lib/api';
import { getLocalizedErrorMessage } from '@/lib/error-i18n';

export const usePublicProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getPublicProfile = async (userId: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await usersAPI.getPublicProfile(userId);

      if (response.success) {
        return { success: true, data: response };
      } else {
        throw new Error(response.message || 'Failed to fetch public profile');
      }
    } catch (err: any) {
      const errorMessage = getLocalizedErrorMessage(err, 'errors.loadProfileFailed');
      setError(errorMessage);

      return { success: false, error: errorMessage };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    getPublicProfile,
  };
};
